import { hasAnyRole } from "../utils/auth";

/*
 * The Keycloak client roles of the loans backend, in one place. They mirror the backend's
 * LoansRoles and its authorization matrix; the screens use them only to decide what to show.
 * IMPORTANT: for UI purposes only; the backend checks every request.
 */
/**
 * The Keycloak realm roles, which keep the names the backend's principal_role table already
 * used. One set of names therefore covers Keycloak tokens and the password login.
 */
export const ROLES = {
  // The HEC administrator (all of HECMIS); renamed from "Admin", which utils/auth still reads as this
  ADMIN: "SCHOLARSHIP_ADMIN",
  DG: "DG",
  // Makes the final approval of government loans
  MINISTER: "MINISTER",
  // The Development Bank of Rwanda: buys tickets and pays approved government loans out
  BRD: "BRD",
  SCHOLARSHIP_OWNER: "SCHOLARSHIP_OWNER",
  HLI_ADMIN: "HLI_ADMIN",
  // HEC staff who mark scholarship applications
  EVALUATOR: "HEC_EVALUATOR",
  APPLICANT: "User",
};

/** Display names, highest first; the first one the user holds is shown as their role. */
const ROLE_LABELS = [
  [ROLES.ADMIN, "Scholarship Admin"],
  [ROLES.DG, "DG"],
  [ROLES.MINISTER, "Minister"],
  [ROLES.BRD, "BRD"],
  [ROLES.SCHOLARSHIP_OWNER, "Scholarship Owner"],
  [ROLES.HLI_ADMIN, "HLI Admin"],
  [ROLES.EVALUATOR, "Evaluator"],
  [ROLES.APPLICANT, "Applicant"],
];

/** A display name for the user's main role (display only; never use it for decisions). */
export const roleLabel = () => {
  const match = ROLE_LABELS.find(([role]) => hasAnyRole(role));
  return match ? match[1] : null;
};

/** The page a user starts on after sign-in, and where the logo and "Home" links go. */
export const homePath = () => {
  if (hasAnyRole(ROLES.ADMIN)) return "/dashboard";
  if (hasAnyRole(ROLES.DG)) return "/applicantsList";
  if (hasAnyRole(ROLES.MINISTER)) return "/loans/abroad/approvals";
  if (hasAnyRole(ROLES.BRD)) return "/loan-payments";
  // Scholarship owners represent a partner (the sponsor) of cooperation scholarships
  if (hasAnyRole(ROLES.SCHOLARSHIP_OWNER)) return "/partner";
  if (hasAnyRole(ROLES.HLI_ADMIN)) return "/hliAdmin";
  if (hasAnyRole(ROLES.EVALUATOR)) return "/evaluation";
  return "/studentPortal";
};
